// @flow
const DebounceUtil = {};

/*
 * NOTE: as of now, this function only passes the call through ONCE, regardless of
 * what the argument function actually is. This should be modified to keep track
 * of which functions have been called.
 */
export const once = (fn: Function) => {
  let isExecuted = false;
  return (...args: Array<any>) => {
    if (isExecuted) {
      return;
    }
    isExecuted = true;
    fn(...args);
  };
};

export default DebounceUtil;
